import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-ship-list',
  templateUrl: './ship-list.component.html',
  styleUrls: ['./ship-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShipListComponent implements OnInit {

  @Input() selected: any[];
  @Input() mapParams: any;
  @Output() onShowBubble = new EventEmitter<any>();
  @Output() onHideBubble = new EventEmitter<any>();
  @Output() onOpenParamsModal = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

  getColor(index: number, field: string): string {
    return this.mapParams.customParams[index + ''] ? this.mapParams.customParams[index + ''][field] : this.mapParams[field];
  }

  showBubble(s: any): void {
    this.onShowBubble.emit(s);
  }

  hideBubble(s: any): void {
    this.onHideBubble.emit(s);
  }

  openParamsModal(s: any): void {
    this.onOpenParamsModal.emit(s);
  }
}
